<div class="app-layout">
  <mat-toolbar color="primary">
    <!-- Home Button moved before the title -->
    <a mat-button class="home-button" routerLink="/">
      <mat-icon>home</mat-icon>
    </a>

    <span class="toolbar-title">Route Sales</span>
    <span class="spacer"></span>

    <!-- Cart Button with Item Count -->
    <a mat-button class="cart-button" routerLink="/place-order" [class.disabled]="isCartEmpty">
      <span class="cart-wrapper">
        <mat-icon>shopping_cart</mat-icon>
        <span class="cart-badge" *ngIf="cartCount$ | async as count">{{ count }}</span>
      </span>
    </a>
  </mat-toolbar>

  <!-- Global busy spinner -->
  <div class="busy-overlay" *ngIf="isBusy | async">
    <mat-progress-spinner color="accent"
                          mode="indeterminate"
                          diameter="50">
    </mat-progress-spinner>
  </div>

  <div class="main-container">
    <router-outlet></router-outlet>
  </div>
</div>
